// Widget-Plugin: Pie Chart (Kreisdiagramm)
vcDashboardRegistry.register("pie", {
    defaults: { w: 20, h: 12, resizable: true, copyable: true, showSettings: true, openSettingsOnCreate: true, pushOthers: false, category: "charts", get menuLabel() { return vcDashboardResources.get("menuCharts"); }, menuOrder: 1 },
    settingsDefaults: { SignalIds: [], IsCumulated: false, Interval: 0, ChartType: "pie", ComparisonMode: 0, ComparisonOffset: -1, PriceCo2: 0 },
    get popupTitle() { return vcDashboardResources.get("pieChartSettings"); },
    render: function ($container, item) {
        $container.html("<div class='dashboard-charts-wrapper'>" + item.title + "</div>");
    },
    buildParams: function (settings, status) {
        return vcDashboardPopup.buildChartParams(settings, status);
    },
    loadChart: function ($item, settings) {
        var resolved = vcDashboardPopup.resolveEffectiveSettings($item, settings);
        var obj = $item.find(".dashboard-charts-wrapper");
        obj.empty();
        obj.height($item.height() - 20);

        var params = this.buildParams(resolved.effectiveSettings, resolved.status);

        obj.DashboardPie({ invokeType: "addVisualBase", parameter: params.Param, signalParameter: params.SignalParam });
    },
    onLoad: function ($item, settings) {
        this.loadChart($item, settings);
    },
    popupLayout: "twocolumn",
    buildFields: function (currentSettings, $el) {
        var signalOptions = vcDashboardPopup.getSignalOptions($el);
        var fields = [];
        if (signalOptions.length) {
            fields.push({ key: "SignalIds", label: vcDashboardResources.get("measurementPoint"), type: "signallist", options: signalOptions, column: "right" });
        }
        fields.push({ key: "Interval", label: vcDashboardResources.get("interval"), type: "select", options: [{value:0,text:vcDashboardResources.get("inheritFromMenu")},{value:1,text:vcDashboardResources.get("singleValues")},{value:2,text:vcDashboardResources.get("dailyValues")},{value:3,text:vcDashboardResources.get("monthlyValues")}], column: "left" });
         fields.push({ key: "PriceCo2", label: vcDashboardResources.get("priceCo2"), type: "select", options: [{value:0,text:vcDashboardResources.get("noSelection")},{value:1,text:vcDashboardResources.get("prices")},{value:2,text:vcDashboardResources.get("co2")}], column: "left" });
        return fields;
    },
    onSettingsSave: function ($el, newSettings) {
        this.loadChart($el, newSettings);
    },
    init: function ($item, settings) {
        vcDashboardPopup.initPlugin($item, this, settings);
    },
    resize: function ($item, settings) {
        this.loadChart($item, settings);
    }
});
